import React from 'react';
import { browserHistory } from 'react-router';
import Toaster from 'toastr';
import ErrorLabel from '../../common/errorLabel';
import FloatInput from '../../common/floatInput';
import Progress from '../../common/progress';
import NetworkErrorDiv from '../../common/networkErrorDiv';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import { permissioned } from '../../common/permissionedHoc';
import ArbiterApi from '../../../api/ArbiterApi';
import DisputesApi from '../../../api/DisputesApi';
import TransactionsApi from '../../../api/TransactionsApi';
import Util from '../../../util/util';
import RouteConfig from '../../../configurations/routesConfig';



class NewClaimModalContent extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            category: '',
            reasonCode: '',
            dispenseType: '',
            transaction: null,
            reasonCodes: [],
            validity: {
                dispensedAmount: -1,
                reasonCode: -1,
                dispenseType: -1,
                category: -1

            },
            loadingTransaction: 0,
            createAnother: false
        };

        this.onDisputeCategoryChange = this.onDisputeCategoryChange.bind(this);
        this.onDispensedAmountChange = this.onDispensedAmountChange.bind(this);
        this.onSelectInputTypeChange = this.onSelectInputTypeChange.bind(this);
        this.onDispenseTypeChange = this.onDispenseTypeChange.bind(this);
        this.handleCreateDispute = this.handleCreateDispute.bind(this);
    }

    componentDidMount() {
        let transaction = this.props.transaction;
        if (this.props.isDisputeReOpen) { //A dispute recreation/reopen
            //use transaction property 
            this.setState({ transaction: transaction });
        }
        else {

            this.setState({ loadingTransaction: 1 });
            TransactionsApi
                .getTransaction(transaction.transactionReference, transaction.transactionType)
                .then(response => {
                    this.setState({ loadingTransaction: 0, transaction: response.data });
                })
                .catch(error => {
                    this.setState({ loadingDispute: -1 });
                    Toaster.error(error.statusText, `${error.status} - ${Messages.ERROR_TRANSACTION_FETCH} `);
                    console.log(error);
                })

        }

    }

    handleCreateDispute(evt) {
        //TODO Validate Controls
        let categoryValid = this.state.category ? 1 : 0;
        let reasonCodeValid = this.state.reasonCode ? 1 : 0;
        let dispenseTypeValid = this.state.dispenseType ? 1 : 0;
        let dispensedAmountValid = 1
        if (this.state.dispenseType === Constants.TRANSACTIONS_DISPENSE_PARTIAL) {
            dispensedAmountValid = this.state.dispensedAmount && Constants.REG_EXPR_VALID_AMOUNT.test(this.state.dispensedAmount);

        }

        //If a control is invalid
        if (!categoryValid || !reasonCodeValid || !dispenseTypeValid || !dispensedAmountValid) {
            let validity = Util.clone(this.state.validity);
            validity.category = categoryValid;
            validity.reasonCode = reasonCodeValid;
            validity.dispenseType = dispenseTypeValid;
            validity.dispensedAmount = dispensedAmountValid;
            this.setState({ validity: validity });
            return;
        }

        this.setState({ loading: true });
        let params = {
            category: this.state.category,
            reasonCode: this.state.reasonCode,
            dispenseType: this.state.dispenseType,
            transactionType: this.state.transaction.transactionType,
            transactionReference: this.state.transaction.transactionReference,
            dispensedAmount: this.state.dispenseType === Constants.TRANSACTIONS_DISPENSE_PARTIAL ? this.state.dispensedAmount : null
        };

        let disputePromise;
        if(this.props.isDisputeReOpen){
            params.action = Constants.DISPUTE_ACTION_REOPEN;
            disputePromise = DisputesApi.reOpenDispute(this.state.transaction.logCode, params);
        }
        else{
            disputePromise  = DisputesApi.createDispute(params);
        }
        
        
        disputePromise.then((response) => {
            Toaster.success(`${response.data.logCode} - ${Messages.SUCCESS_DISPUTE_CREATION}`);
            this.setState({ loading: false });
            if (this.state.createAnother || this.props.isDisputeReOpen ) //close modal for a re-open
                this.props.closeModal(evt, this.props.isDisputeReOpen);
            else
                browserHistory.push(RouteConfig.DISPUTES_ROUTE.path);
        })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTE_CREATION} - ${error.data.description}`, `${Messages.ERROR_DISPUTE_CREATION} - ${error.status}`);
                this.setState({ loading: false });
            })
    }

    onDisputeCategoryChange(event) {
        let value = event.target.value;
        //Clear reason Codes
        this.setState({ reasonCodes: [] });
        //Fetch new ones
        if (value) {
            ArbiterApi
                .getReasonCodesByCategory(value)
                .then((response) => {
                    let reasonCodes = response.data;
                    this.setState({ reasonCodes: reasonCodes });
                })
                .catch((error) => {
                    Toaster.error(Messages.ERROR_REASON_CODES, "Reason Codes");
                    console.log(error);
                });

        }
        let validity = Util.clone(this.state.validity);
        validity.category = value ? 1 : 0;
        this.setState({ category: value, validity: validity });
    }
    onSelectInputTypeChange(event) {
        let value = event.target.value, name = event.target.name;
        let validity = Util.clone(this.state.validity);
        validity[name] = value ? 1 : 0;
        this.setState({ [name]: value, validity: validity });
    }
    onDispenseTypeChange(event) {
        let value = event.target.value;
        let validity = Util.clone(this.state.validity);
        validity.dispenseType = value ? 1 : 0;

        //DispenseAmount not needed if not partial dispense
        if (value !== Constants.TRANSACTIONS_DISPENSE_PARTIAL) {
            validity.dispensedAmount = -1;
        }
        this.setState({ dispenseType: value, validity: validity });
    }
    onDispensedAmountChange(event) {
        let val = event.target.value;
        let dispensedAmountValid = (val && Constants.REG_EXPR_VALID_AMOUNT.test(val)) ? 1 : 0;
        let validity = Util.clone(this.state.validity);
        validity.dispensedAmount = dispensedAmountValid;
        this.setState({ dispensedAmount: val, validity: validity })
    }

    render() {
        return (
           <div>
                {this.state.loadingTransaction === 1 &&
                    <Progress />
                }
                {this.state.loadingTransaction === -1 &&
                    <NetworkErrorDiv title="" description="" />
                }
                {this.state.transaction &&
                    <div>
                        <div className="mod-content">
                            <form>
                                <div className="row">
                                    <div className=" col-md-6">
                                        <div className="form-div">
                                            <label>Issuer :</label>
                                            <label>{this.state.transaction.issuer}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Acquirer :</label>
                                            <label>{this.state.transaction.acquirer}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Merchant :</label>
                                            <label>{this.state.transaction.merchant || "-" }</label>
                                        </div>
                                        
                                        <div className="form-div">
                                            <label>Tran. Date :</label>
                                            <label>{this.state.transaction.transactionDate}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Type :</label>
                                            <label>{this.state.transaction.transactionType}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Amount :</label>
                                            <label>{this.state.transaction.transactionAmount ? `${this.state.transaction.transactionCurrency} ${this.state.transaction.transactionAmount}` : '-'}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Surcharge Amount. :</label>
                                            <label>{this.state.transaction.surchargeAmount ? `${this.state.transaction.transactionCurrency} ${this.state.transaction.surchargeAmount}` : "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Settlement Amount :</label>
                                            <label>{this.state.transaction.settlementAmount ? `${this.state.transaction.settlementCurrency} ${this.state.transaction.settlementAmount}` : "-"}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Tran. Ref. :</label>
                                            <label>{this.state.transaction.transactionReference}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Customer Ref. :</label>
                                            <label>{this.state.transaction.customerReference}</label>
                                        </div>
                                        
                                        <div className="form-div">
                                            <label>Terminal Type :</label>
                                            <label>{this.state.transaction.terminalType}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>Terminal ID :</label>
                                            <label>{this.state.transaction.terminalId}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>PAN :</label>
                                            <label>{this.state.transaction.pan}</label>
                                        </div>
                                        <div className="form-div">
                                            <label>STAN :</label>
                                            <label>{this.state.transaction.stan}</label>
                                        </div>


                                    </div>
                                    <div className=" col-md-6">
                                        {
                                            this.props.isDisputeReOpen && 
                                            <div className="form-div">
                                            <label>Log Code : </label>
                                            <label>{this.state.transaction.logCode}</label>
                                            </div>
                                        }

                                        <div className="form-div">
                                            <label>Card Acceptor Loc. :</label>
                                            <label>{this.state.transaction.cardAcceptorLocation}</label>
                                        </div>
                                        
                                        <div className="form-div">
                                            <label>Card Acceptor Code :</label>
                                            <label>{this.state.transaction.cardAcceptorCode}</label>
                                        </div>


                                        {
                                            this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 &&
                                            < div id="categorySection">

                                                <div className="form-div">
                                                    <label>Dispense type :</label>
                                                    <div>
                                                        <select
                                                            name="dispenseType"
                                                            id="dispenseType"
                                                            value={this.state.dispenseType}
                                                            onChange={this.onDispenseTypeChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            <option value={Constants.TRANSACTIONS_DISPENSE_PARTIAL}>{Constants.TRANSACTIONS_DISPENSE_PARTIAL}</option>
                                                            <option value={Constants.TRANSACTIONS_NO_DISPENSE}>{Constants.TRANSACTIONS_NO_DISPENSE}</option>
                                                        </select>
                                                        {
                                                            (this.state.validity.reasonCode === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_DISPENSE_TYPE} />
                                                        }
                                                    </div>
                                                </div>
                                                {this.state.dispenseType !== Constants.TRANSACTIONS_NO_DISPENSE &&
                                                    <div className="form-div">
                                                        <label>Dispensed Amount. :</label>
                                                        <FloatInput
                                                            id="dispensedAmount"
                                                            value={this.state.dispensedAmount}
                                                            onChange={this.onDispensedAmountChange}
                                                            placeholder="Enter amount"
                                                            showError={!this.state.validity.dispensedAmount} errorMessage={`${Messages.INVALID_REQUESTED_AMOUNT}`} />

                                                    </div>
                                                }
                                                < div className="form-div">
                                                    <label>Dispute Category :</label>
                                                    <div>
                                                        <select
                                                            name="category"
                                                            id="category"
                                                            value={this.state.category}
                                                            onChange={this.onDisputeCategoryChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            {this.state.transaction.disputeCategories.map(category => {
                                                                return (<option key={category} value={category}>{category}</option>);
                                                            })}
                                                        </select>
                                                        {
                                                            (this.state.validity.category === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_DISPUTE_CATEGORY} />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="form-div">
                                                    <label>Reason :</label>
                                                    <div>
                                                        <select
                                                            name="reasonCode"
                                                            id="reasonCode"
                                                            
                                                            value={this.state.reasonCode}
                                                            required={true}
                                                            onChange={this.onSelectInputTypeChange}
                                                        >
                                                            <option value="">--- Select ---</option>
                                                            {
                                                                this.state.reasonCodes.map((val) => { return (<option key={val.code} value={val.code}>{val.name}</option>) })
                                                            }
                                                        </select>
                                                        {
                                                            (this.state.validity.reasonCode === 0) &&
                                                            <ErrorLabel message={Messages.INVALID_REASON_CODE} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        }
                                        <div className="form-div">
                                            <label>Additional Info :</label>
                                            <textarea readOnly="true" style={{ width: "80%", height: "130px", fontSize: "12px" }} value={JSON.stringify(this.state.transaction.additionalInfo, null, 2)} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="mod-footer">
                            {this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 && !this.props.isDisputeReOpen &&
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={this.state.createAnother} onChange={(event) => { this.setState({ createAnother: event.target.checked }) }} />
                                        <span className="lbl"> Create Another</span>
                                    </label>
                                </div>
                            }
                            <div className="mod-footer-buttons">
                                {this.state.transaction.disputeCategories && this.state.transaction.disputeCategories.length !== 0 && <button onClick={this.handleCreateDispute} disabled={!this.isFormValid()} className="btn btn-primary">CREATE</button>}
                                <button onClick={this.props.closeModal} className="btn btn-danger">CLOSE</button>
                            </div>

                        </div>
                    </div>
                }
            </div>
        )
    }

    isFormValid() {
        let valid = true;
        for (let key in this.state.validity) {
            valid = valid && (this.state.validity[key] !== 0);
        }
        return valid;
    }
}

export default permissioned(NewClaimModalContent);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimModalContent.js